import axios from "axios";
import moment from "moment";
import React, { useRef, useState } from "react";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import ReportTypeCard from "../../../../components/Custom/ReportTypeCard";
import Header from "../../../../components/Headers/Header";
import HeaderWithDownload from "../../../../components/HeaderWithDownload";
import ConfirmModal from "../../../../components/Modals/ConfirmModal";
import { CSVLink } from "react-csv";
import {
  IRamedialReports,
  ISelectedFilters,
  ISelectedFiltersUsingName,
} from "../../../../types";
import FiltersUsingName from "../../Components/Filter/FiltersUsingName";
import { useTotalRamedialTest } from "./hooks/useTableReports";
import FullPageLoader from "../../../../components/Loader/FullPageLoader/FullPageLoader";
import { toast } from "react-toastify";
import { JAVA_DASHBOARD_API } from "../../../../constants";
import { getDataRangeByWeekNo } from "../../../../Services/utils";
import { handleDownload } from "../../../../utilityFunctions";
import DropDown from "../../../../components/DropDown/DropDown";
import MonthlyReports from "./MonthlyReports/MonthlyReports";

export default function AllTableReports() {
  const {
    isDownloadingReport,
    setIsDownloadingReport,
    selectedFilters,
    setSelectedFilters,
    showFilterAlert,
    setShowFilterAlert,
    selectedFilterForReport,
    setSelectedFilterForReport,
    reportData,
    setReportData,
    fileName,
    setFileName,
    refDownloadFile,
    fetchRamedialTest,
    AllReportsName,
    AllTeacherReports,
    eAdhighamReports,
    weeKForAPi,
    fetchWeeklyStudentSubjectWiseReport,
    fetchWeeklyStudentAdhigamReport
  } = useTotalRamedialTest();
  return (
    <div>
      <Header />
      <ConfirmModal
        isOpen={showFilterAlert}
        onClose={() => setShowFilterAlert((prev) => !prev)}
        type={"warning"}
        title={`Data size will be too large.`}
        subtitle="Please select filters for district & block"
        hideCancelButton
        onConfirm={() => {
          setShowFilterAlert(false);
        }}
      />
      <Container className="mt-n7" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0">
            <h3 className="mb-0 text-muted">
              <i className="fas fa-file-invoice mr-1"></i> Reports & Analysis
            </h3>
            <FiltersUsingName
              hasDistrictFilter
              hasBlockFilter
              hasSchoolFilter
              hasWeekSelector
              hasYearSelector
              onClear={() => {
                setSelectedFilters(undefined);
                setSelectedFilterForReport(undefined);
              }}
              onFilterChange={(value) => {
                setSelectedFilterForReport(value);
                setSelectedFilters(value);
              }}
            />
          </CardHeader>
          <CardBody>
            <div className="d-flex justify-content-center">
              <button ref={refDownloadFile} className="d-none">
                <CSVLink
                  data={reportData?.data ? reportData?.data : []}
                  headers={reportData?.headers ? reportData?.headers : []}
                  filename={`${fileName}.csv`}
                >
                  Download List <i className="fas fa-file-download ml-1"></i>
                </CSVLink>
              </button>
            </div>

            <div>
              <h3 className="p-3">
                <i className="fas fa-file-invoice mr-1"></i>Weekly e-Adhigam Reports
              </h3>
              <div className="reports-grid">
                {!isDownloadingReport ?
                  <>
                    {
                      eAdhighamReports.map((each) => (
                        <ReportTypeCard
                          title={each?.title}
                          description={each?.description}
                          navigateTo={() => selectedFilterForReport?.week_no ?
                            fetchRamedialTest(
                              each?.navigateTo,
                              each?.title,
                              "eadhigam"
                            ) : toast.warn("Week must be selected for weekly e-Adhigam reports")
                          }
                        />
                      ))}

                    {/* TODO: update the endpoint and functionality here */}
                    <ReportTypeCard
                      title={"Subject Wise Weekly Student Report"}
                      description={"Subject wise weekly student report"}
                      navigateTo={() => {
                        selectedFilterForReport?.week_no ?
                          fetchWeeklyStudentSubjectWiseReport()
                          // fetchRamedialTest(
                          //   "other",
                          //   "Subject Wise Weekly Student Report",
                          //   "subjectWiseWeeklyStudentReport"
                          // )
                          : toast.warn("Week must be selected for weekly student reports")
                      }}
                    />
                  </>
                  :
                  <FullPageLoader />
                }
                <ReportTypeCard
                  title={"Detailed e-Adhigam Student Data"}
                  description={"Student wise weekly e-Adhigam and usages"}
                  navigateTo={() =>
                    selectedFilterForReport?.week_no ?
                      // fetchRamedialTest(
                      //   "Other",
                      //   "Detailed e-Adhigam Student Data",
                      //   "Detailede-AdhigamStudentData"
                      // )
                      fetchWeeklyStudentAdhigamReport()
                      : toast.warn("Week must be selected for weekly e-Adhigam reports")
                  }
                />
              </div>
            </div>

            <div>
              <h3 className="p-3">
                <i className="fas fa-file-invoice mr-1"></i>Teachers Reports
              </h3>
              <div className="reports-grid">
                {!isDownloadingReport ? (
                  AllTeacherReports.map((each) => (
                    <ReportTypeCard
                      title={each?.title}
                      description={each?.description}
                      navigateTo={() =>
                        fetchRamedialTest(
                          each?.navigateTo,
                          each?.title,
                          "teacher"
                        )
                      }
                    />
                  ))
                ) : (
                  <FullPageLoader />
                )}
                <ReportTypeCard
                  title={"Time Spent by Teachers on Student Monitoring (in mins)"}
                  description={"Teachers Time Spent On Student Monitoring"}
                  navigateTo={() => {
                    fetchRamedialTest(
                      "Other",
                      "Time Spent by Teachers on Student Monitoring (in mins)",
                      "studentMonitoring"
                    )
                    // : toast.warn("Week must be selected for time spent on student monitoring")
                  }}
                />
              </div>
            </div>

            <div>
              <h3 className=" p-3">
                <i className="fas fa-file-invoice mr-1"></i>Students Reports
              </h3>
              <div className="reports-grid">
                {!isDownloadingReport ? (
                  AllReportsName.map((each) => (
                    <ReportTypeCard
                      title={each?.title}
                      description={each?.description}
                      navigateTo={() =>
                        fetchRamedialTest(
                          each?.navigateTo,
                          each?.title,
                          "student"
                        )
                      }
                    />
                  ))
                ) : (
                  <FullPageLoader />
                )}
                {/* <ReportTypeCard
                    title={"Subject Wise Weekly Student Report"}
                    description={"Subject wise weekly student report"}
                    navigateTo={() =>
                      {
                        selectedFilterForReport?.week_no ?
                        fetchRamedialTest(
                          "other",
                          "Subject Wise Weekly Student Report",
                          "subjectWiseWeeklyStudentReport"
                        )      
                        : toast.warn("Week must be selected for weekly student reports")
                      }}
                  /> */}
              </div>
            </div>
          </CardBody>
        </Card>

        {/* MONTHLY REPORTS */}
        <MonthlyReports />
      </Container>
    </div>
  );
}